// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file mars/mars_task_stream.proto (package vsmr.mars.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { NamedValue } from "./mars_task_common_pb.js";

/**
 * MINOR EDIT (G_MOD13) - ordered list defined in MARS input
 * Topic: ui.minoredit.v1
 * Key: task_id (recommended)
 *
 * @generated from message vsmr.mars.v1.MinorEditSnapshot
 */
export class MinorEditSnapshot extends Message<MinorEditSnapshot> {
  /**
   * Task identifier (from --task-id)
   *
   * @generated from field: string task_id = 1;
   */
  taskId = "";

  /**
   * Monotonically increasing sequence number (per task)
   *
   * @generated from field: int64 seq = 2;
   */
  seq = protoInt64.zero;

  /**
   * Unix Epoch timestamp in milliseconds (wall-clock)
   *
   * @generated from field: int64 ts_ms = 3;
   */
  tsMs = protoInt64.zero;

  /**
   * Simulation problem time [ms] (m_timehy × 1000)
   *
   * @generated from field: int64 timehy = 4;
   */
  timehy = protoInt64.zero;

  /**
   * Ordered list, same order as defined in MARS input
   *
   * @generated from field: repeated vsmr.mars.v1.NamedValue values = 10;
   */
  values: NamedValue[] = [];

  constructor(data?: PartialMessage<MinorEditSnapshot>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.mars.v1.MinorEditSnapshot";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "task_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "seq", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "ts_ms", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "timehy", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 10, name: "values", kind: "message", T: NamedValue, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MinorEditSnapshot {
    return new MinorEditSnapshot().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MinorEditSnapshot {
    return new MinorEditSnapshot().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MinorEditSnapshot {
    return new MinorEditSnapshot().fromJsonString(jsonString, options);
  }

  static equals(a: MinorEditSnapshot | PlainMessage<MinorEditSnapshot> | undefined, b: MinorEditSnapshot | PlainMessage<MinorEditSnapshot> | undefined): boolean {
    return proto3.util.equals(MinorEditSnapshot, a, b);
  }
}

